import { render, staticRenderFns } from "./TsuIcon.vue?vue&type=template&id=de568a4e"
import script from "./TsuIcon.vue?vue&type=script&lang=js"
export * from "./TsuIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports